<div class="search-block">
    <div class="container">
    <div>
<div  id="home_nav" class="row">
    <div class="col-md-6 col-7 col-lg-6 breadcrumb-header">
        <ol class="breadcrumb loginMenu">
            <li class="breadcrumb-item"  style="align-items: center;float:right;">
                <a class="bd-crumb-inactive" (click)="handleNavigation('home')">Home</a>
            </li>
            <li class="breadcrumb-item active" >{{i18n['shp.articles.title']}}</li>
        </ol>
    </div>
    <!-- <div class="col-md-6 search-header"><span>{{i18n['shp.articles.title']}}</span>
    </div> -->
    <div class="input-group col-md-5 col-5 col-lg-5 searchContainer">
        <ng-autocomplete class="form-control py-2 searchBox" [data]="data" [searchKeyword]="keyword" [(ngModel)]="searchKey"
        (selected)='selectEvent($event)' (inputChanged)='onChangeSearch($event)' 
        [itemTemplate]="itemTemplate" [notFoundTemplate]="notFoundTemplate" (keydown.enter)="onKeyEnterSearch($event,searchKey)" aria-label="Type here to Search an Article"
        placeholder="{{searchTextboxNote}}" title="{{searchTextboxHover}}">
      </ng-autocomplete>
      <ng-template #itemTemplate let-item>
        <a [innerHTML]="item.name"></a>
      </ng-template>
      <ng-template #notFoundTemplate let-notFound>
        No Suggestion...
      </ng-template>
        <span class="input-group-append" (click)="search(searchKey)">
        <button class="btn btn btn-primary searchBtn" type="button" title="{{searchButtonHover}}" aria-label="Click here to Search an Article">
          <i class="fa fa-search"></i>
        </button>
      </span>
      <!-- <div class="col-md-12">
        <ol class="breadcrumb loginMenu">
            <li class="breadcrumb-item">
                <a class="bd-crumb-inactive" (click)="handleNavigation('home')">Home</a>
            </li>
            <li class="breadcrumb-item active" >
                Login
            </li>
        </ol>
    </div> -->
    </div> 
</div>
</div>
</div>
</div>
<div data-auto-dismiss="10000"  *ngIf="alert==true && delayed==false"
  class="alert alert-success alert-dismissible fade show" style="position: absolute; right: 20px; z-index: 999;margin-top: 10px;padding: 0.75rem 1rem;" data-auto-dismiss role="alert">
    <p>Case saved successfully, case number is {{caseAlertMessage}}</p>
</div>
<div class="BgColor article">
    <div class="container p-0 article-bgrnd">
        <div class="section">
            <div class="icon"><a [routerLink]="['../searchresults']" (click)="searchResult()" class="fa fa-arrow-left" aria-hidden="true"></a>
                <a [routerLink]="['../searchresults']" (click)="searchResult()">{{i18n['shp.back']}}</a>
            </div>
            <h4 [innerHtml]="articleTitle"></h4>
            <p [innerHtml]="selectedValue"></p>
            <div class="date"><p>{{i18n['shp.last.updated']}} {{lastUpdated | date:"MM-dd-yyyy  h:mma"}} <br> {{i18n['shp.article.id']}} {{articleExternalId}}</p>
            </div>
            <mat-card class="mat-elevation-z0 outline">
                <p class="improve" [innerHtml] = "i18n['article.feedback']" > </p>
                <mat-card-actions *ngIf = "!isFeedbackSuccess">
                    <button mat-button class="yes" (click)="getFeedback('YES')">{{i18n['shp.articles.yes']}}</button>
                    <button mat-button class="no" (click)="getFeedback('NO')">{{i18n['shp.articles.no']}}</button>
                </mat-card-actions>
                <p class="improve" [innerHtml] = "i18n['shp.articles.thanksYou']" *ngIf = "isFeedbackSuccess"> </p>
            </mat-card>          
        </div>
    </div>
    <div class = "card-container" *ngIf="innerWidth > 767">
        <div class = "card">
            <div class= "card-body">
                <div class="card-header" >
                    <strong>{{topArticleTitle}}</strong>
                </div>
                <ul style="list-style-type:none;padding-left: 20px;">
                    <div *ngFor="let article of topArticles.items">
                      <a class="top-articles-tooltip" [routerLink]="['../article']" [queryParams]="{articleId: article.article_id}">
                        <li class="toparticles-block">
                          {{article.article_title}}
                        </li>
                        <span class="top-articles-tooltip-text" style="pointer-events : none;">{{article.article_title}}</span>
                      </a>
                  </div>
                </ul>
            </div>
        </div>
    </div>    
